export const initialState = {
    podcastList: [],
    activePodcast:null
};